import React from "react";
import {
  HiOutlineHome,
  HiOutlineUserGroup,
  HiOutlineUser,
  HiOutlineBookOpen,
  HiOutlineCube,
  HiOutlineGlobeAlt,
  HiOutlineHeart,
  HiOutlineShare,
  HiOutlinePhoto,
  HiOutlineShieldCheck,
} from "react-icons/hi2";

const ICON_CLASS = "w-5 h-5 shrink-0";

const ICONS = {
  dashboard: <HiOutlineHome className={ICON_CLASS} />,
  community: <HiOutlineUserGroup className={ICON_CLASS} />,
  profile: <HiOutlineUser className={ICON_CLASS} />,
  recipes: <HiOutlineBookOpen className={ICON_CLASS} />,
  sharedRecipes: <HiOutlineShare className={ICON_CLASS} />,
  fridge: <HiOutlineCube className={ICON_CLASS} />,
  worldMenus: <HiOutlineGlobeAlt className={ICON_CLASS} />,
  favorites: <HiOutlineHeart className={ICON_CLASS} />,
  poster: <HiOutlinePhoto className={ICON_CLASS} />,
  admin: <HiOutlineShieldCheck className={ICON_CLASS} />,
};

/**
 * Retourne l’icône react-icons correspondant à iconName.
 */
export function getNavIcon(iconName) {
  return ICONS[iconName];
}
